const React = require("react")

exports.onRouteUpdate = ({ prevLocation }) => {
  window.prevLocation = prevLocation
}
